<template>
  <div class="home"  v-scroll-reveal="{scale:2}">
    <!-- slider -->
    <carousel />
    <!-- CARDS -->
    <cards-component></cards-component>
    <!-- ENTERATE -->
    <enterate-component></enterate-component>
    <!-- BOLETIN OFICIAL (por el momento deshabilitado en el home de ciudadanos) -->
    <prensa-home class=""></prensa-home>
    <!-- OTROS ENLACES -->
    <!-- <otros-enlaces class="mb-5"></otros-enlaces> -->
    <!-- SOCIAL MEDIA -->
    <social-media></social-media>
    <!-- CONTACTANOS -->
    <!-- <contactanos-component class=""></contactanos-component> -->

        <!-- modal para carrusel -->
    <vs-dialog width="550px" not-center v-model="active">
      <template #header>
        <h4 class="not-margin">
          Welcome to <b>Vuesax</b>
        </h4>
      </template>
      <div class="con-content">
        <p>
          Vuesax is a relatively new framework with a refreshing design and in the latest trends, vuesax based on vuejs which means that we go hand in hand with one of the most popular javascript frameworks in the world and with a huge community with which you will have all the help and documentation to create and make your project
        </p>
      </div>
      <template #footer>
        <div class="con-footer">
          <vs-button @click="active=false" transparent>
            Ok
          </vs-button>
        </div>
      </template>
    </vs-dialog>
<!-- @click="active=!active" -->

  </div>
</template>

<script>
// @ is an alias to /src
import msjSecretario from './msjSecretario.vue'
import cardsComponent from './Cards-component.vue'
import enterateComponent from './Enterate-component.vue'
import prensaHome from './prensa.vue'
import otrosEnlaces from './Otros-enlaces.vue'
import socialMedia from './social-media.vue'
import contactanosComponent from './Contactanos'
import SalaPrensa from '../sala-de-prensa/SalaPrensa.vue'
import carousel from './carusel.vue'

export default {
  name: 'Home',
  computed:{
    dispositivo(){
        if(screen.width>900) return true;
        else return false;
    }
   },
    mounted(){
        window.scrollTo(0, 0);
    },
    data() {
      return {
        active: false
      }
    },
  components: {
    cardsComponent,
    enterateComponent,
    prensaHome,
    otrosEnlaces,
    socialMedia,
    contactanosComponent,
    SalaPrensa,
    msjSecretario,
    carousel
  },
  methods:{
    enlace(){
      console.log('log');
      // const height = screen.height;
      // window.scrollTo(height, height);
    }
  }
}
</script>
<style scoped>
    /* .sizeHeight {height: 85vh;}
    @media screen and (min-device-width : 1366px) {
        .w-100 {
            height: 86vh;
        }
    } */
</style>
